export default __webpack_public_path__ + "static/media/682.06d2f627.png";